module.exports = __webpack_public_path__ + "img/horizontal_7_1_6005.cf08c961.png";